import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import withAuth from './../../common/helper/auth-component.js';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import AgentDashboard from './agent-dashboard.component.js';
import AdminDashboard from './admin-dashboard.component.js';
import MerchantDashboard from './merchant-dashboard.component.js';
import { useSelector } from 'react-redux';
import ConfigService from "../../../services/config-service";
import { MESSAGES } from '../../constants/constants.js';

const Dashboard = () => { 
const userData = useSelector(state => state.authReducer);
const [userRole, setUserRole] = useState()



    useEffect(() => {
      if(userData && userData.user && userData.user.data) {
        setUserRole(userData.user.data.role)
      }
      document.body.style.backgroundImage = '';
      document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
return(
  <>
   <AgentDashboard />
  {/* {( ConfigService.checkUserPermission('dashboard_agent')) && (
    <AgentDashboard />
  )}
 
   {( ConfigService.checkUserPermission('dashboard_owner')) && (
     <AdminDashboard />
   )}
  
    {( ConfigService.checkUserPermission('dashboard_merchant')) && (
      <MerchantDashboard />
    )} */}
    </>
)

}
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(Dashboard));